import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/ai-agents/questionnaire-agent-response']['GET'];
type Input = ThisApi['query'];

const getQuestionnaireAgentResponse = async ({ fieldKey, questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/ai-agents/questionnaire-agent-response');
  const data = await formsBackendClient.get(path, {
    params: { fieldKey, questionnaireId },
  });
  return data.data;
};

export default getQuestionnaireAgentResponse;
